import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Trophy, Link as LinkIcon } from 'lucide-react';
import Link from 'next/link';

const annualEvents = [
  {
    title: '2-Pole Pylon Racing',
    content:
      '6 Events are scheduled for the second Saturday of each month April through September at 10:00am - just prior to the 3 pylon events.',
    cd: 'Dave Pitkin',
    links: [{ label: '2 Pole Rules', href: '#' }],
  },
  {
    title: '3-Pole Pylon Racing',
    content:
      '6 Events are scheduled for the second Saturday of each month April through September at 11:00am following 2 pylon events.',
    cd: 'Russ Horsfall',
    links: [
      { label: 'Electric Rules', href: '#' },
      { label: 'Doubler Rules', href: '#' },
      { label: '1/A Rules', href: '#' },
    ],
  },
  {
    title: 'Duration',
    content:
      '5 SRAC Open Class and F5J Duration Contests are scheduled for the third Saturday of each month May through September. SRAC members are also invited to participate in Radian only Duration events hosted by Seattle Area Soaring (SAS)',
    cd: 'Tom Norman',
    links: [{ label: 'Duration Rules', href: '#' }],
  },
  {
    title: 'Decathlon',
    content:
      'The Decathlon consists of 10 events which may be completed anytime prior to Dec 31 of each year.',
    cd: 'Chris Christensen (425-501-1779)',
    links: [
      { label: 'Decathlon Rules', href: '#' },
      { label: 'Decathlon Events', href: '#' },
      { label: 'Decathlon Score Sheet', href: '#' },
    ],
  },
  {
    title: 'Fun fly',
    content: 'Fun Fly events are scheduled in July and August.',
    cd: 'Chris Christensen (425-501-1779)',
    links: [],
  },
];

export default function AnnualEventsCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-primary" />
          Annual Events
        </CardTitle>
        <CardDescription>
          Our yearly competitions and recurring events.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible className="w-full">
          {annualEvents.map((event) => (
            <AccordionItem key={event.title} value={event.title}>
              <AccordionTrigger>{event.title}</AccordionTrigger>
              <AccordionContent>
                <div className="space-y-4">
                  <p className="text-muted-foreground">{event.content}</p>
                  <p className="text-sm">
                    <span className="font-semibold">Contest Director (CD):</span>{' '}
                    {event.cd}
                  </p>
                  {event.links.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {event.links.map((link) => (
                        <Link
                          key={link.label}
                          href={link.href}
                          className="text-sm text-primary underline-offset-4 hover:underline flex items-center gap-1"
                        >
                          <LinkIcon className="w-3 h-3" />
                          {link.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </CardContent>
    </Card>
  );
}
